export default __webpack_public_path__ + "static/media/shipped_green.e5bf570b.svg";